var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2H9.5V1.75C9.5 0.79 8.71 0 7.75 0H5.75C4.79 0 4 0.79 4 1.75V2H3.75C1.68 2 0 3.68 0 5.75V15.75C0 17.82 1.68 19.5 3.75 19.5H9.75C11.82 19.5 13.5 17.82 13.5 15.75V5.75C13.5 3.68 11.82 2 9.75 2ZM5.5 1.75C5.5 1.61 5.61 1.5 5.75 1.5H7.75C7.89 1.5 8 1.61 8 1.75V3H5.5V1.75ZM12 15.75C12 16.99 10.99 18 9.75 18H3.75C2.51 18 1.5 16.99 1.5 15.75V5.75C1.5 4.51 2.51 3.5 3.75 3.5H4V3.75C4 4.16 4.34 4.5 4.75 4.5H8.75C9.16 4.5 9.5 4.16 9.5 3.75V3.5H9.75C10.99 3.5 12 4.51 12 5.75V15.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.5C8.27 11.5 9.5 10.27 9.5 8.75C9.5 7.23 8.27 6 6.75 6C5.23 6 4 7.23 4 8.75C4 10.27 5.23 11.5 6.75 11.5ZM6.75 7.5C7.44 7.5 8 8.06 8 8.75C8 9.44 7.44 10 6.75 10C6.06 10 5.5 9.44 5.5 8.75C5.5 8.06 6.06 7.5 6.75 7.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97049 13.52C9.50049 12.58 8.56049 12 7.51049 12H5.98049C4.93049 12 3.99049 12.58 3.52049 13.52L3.07049 14.41C2.88049 14.78 3.03049 15.23 3.41049 15.42C3.78049 15.61 4.23049 15.45 4.42049 15.08L4.87049 14.19C5.08049 13.76 5.51049 13.5 5.99049 13.5H7.52049C8.00049 13.5 8.43049 13.76 8.64049 14.19L9.09049 15.08C9.22049 15.34 9.49049 15.49 9.76049 15.49C9.87049 15.49 9.99049 15.46 10.0905 15.41C10.4605 15.22 10.6105 14.77 10.4305 14.4L9.98049 13.51L9.97049 13.52Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/I.cff9e4b33f14146927e56820526622bc.svg";
export { ForwardRef as ReactComponent };